import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { annoncesAPI } from '../api';
import '../App.css';

function CataloguePage() {
  const [activeType, setActiveType] = useState('Tous');
  const [activeEtat, setActiveEtat] = useState('Tous');
  const [activeCat, setActiveCat] = useState('Toutes');
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('recent');
  const [priceMax, setPriceMax] = useState(1000000);
  const [annonces, setAnnonces] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);

  const types = ['Tous', 'Automobile', 'Camion', 'Moto', 'Machine'];
  const etats = ['Tous', 'Neuf', 'Occasion'];
  const categories = ['Toutes', 'Moteur', 'Freinage', 'Suspension', 'Electrique', 'Transmission', 'Carrosserie', 'Filtration', 'Hydraulique'];

  useEffect(() => {
    fetchAnnonces();
  }, [activeType, activeEtat, activeCat, searchTerm, priceMax, page]);

  const fetchAnnonces = async () => {
    setLoading(true);
    try {
      const params = { page, limit: 12 };
      if (activeType !== 'Tous') params.type = activeType;
      if (activeEtat !== 'Tous') params.etat = activeEtat;
      if (activeCat !== 'Toutes') params.categorie = activeCat;
      if (searchTerm) params.search = searchTerm;
      if (priceMax < 500000) params.prix_max = priceMax;

      const res = await annoncesAPI.getAll(params);
      let data = res.data.annonces || [];

      if (sortBy === 'prix-asc') data = [...data].sort((a, b) => a.prix - b.prix);
      if (sortBy === 'prix-desc') data = [...data].sort((a, b) => b.prix - a.prix);

      setAnnonces(data);
      setTotal(res.data.total || 0);
    } catch (err) {
      console.error('Erreur chargement annonces:', err);
      setAnnonces([]);
    } finally {
      setLoading(false);
    }
  };

  // Récupère la première photo d'une annonce
  const getFirstPhoto = (photos) => {
    try {
      if (!photos) return null;
      const list = typeof photos === 'string' ? JSON.parse(photos) : photos;
      return list && list.length > 0 ? list[0] : null;
    } catch (e) {
      return null;
    }
  };

  return (
    <div className="app">
      {/* NAV */}
      <nav className="nav">
        <Link to="/" style={{ textDecoration: 'none' }}>
          <div className="logo-wrap">
            <div className="logo">Tek<span>Teck</span></div>
            <div className="logo-tag">rak tak!</div>
          </div>
        </Link>
        <div className="nav-links">
          <Link to="/catalogue" style={{ color: '#F5620A' }}>Catalogue</Link>
          <Link to="/#how" style={{ color: '#888', textDecoration: 'none' }}>Comment ca marche</Link>
          <Link to="/deposer-annonce" style={{ color: '#888', textDecoration: 'none' }}>Vendre</Link>
        </div>
        <div className="nav-actions">
          <Link to="/connexion"><button className="btn-ghost">Se connecter</button></Link>
          <Link to="/deposer-annonce"><button className="btn-orange">Vendre mes pieces</button></Link>
        </div>
      </nav>

      {/* HEADER AD */}
      <div style={{ padding: '8px 48px', background: '#141414', borderBottom: '1px solid #2A2A2A' }}>
        <div className="ad-banner-slot">
          <span className="ad-tag">PUB · HEADER</span>
          <span className="ad-price-tag">25 000 F/sem · 90 000 F/mois</span>
          <div className="ad-content">
            <div className="ad-logo">🔋</div>
            <div className="ad-body">
              <div className="ad-sponsor">EXIDE BATTERIES</div>
              <div className="ad-title">Batteries Exide — Demarrage garanti · 2 ans de garantie · Livraison gratuite a Dakar</div>
            </div>
            <button className="ad-cta">Commander</button>
          </div>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '260px 1fr', gap: '0', minHeight: '100vh' }}>

        {/* SIDEBAR FILTRES */}
        <div style={{ background: '#141414', borderRight: '1px solid #2A2A2A', padding: '24px 20px', position: 'sticky', top: '60px', height: 'calc(100vh - 60px)', overflowY: 'auto' }}>
          <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '18px', letterSpacing: '1px', color: '#fff', marginBottom: '20px' }}>FILTRES</div>

          {/* TYPE */}
          <div style={{ marginBottom: '20px' }}>
            <div style={{ fontSize: '10px', fontWeight: '700', color: '#888', letterSpacing: '.5px', marginBottom: '10px' }}>TYPE DE VEHICULE</div>
            {types.map(t => (
              <div key={t} onClick={() => { setActiveType(t); setPage(1); }}
                style={{ padding: '8px 12px', borderRadius: '7px', cursor: 'pointer', fontSize: '13px', fontWeight: '600', marginBottom: '4px', background: activeType === t ? 'rgba(245,98,10,.15)' : 'transparent', color: activeType === t ? '#F5620A' : '#888', border: activeType === t ? '1px solid rgba(245,98,10,.3)' : '1px solid transparent' }}>
                {t}
              </div>
            ))}
          </div>

          {/* ETAT */}
          <div style={{ marginBottom: '20px', borderTop: '1px solid #2A2A2A', paddingTop: '16px' }}>
            <div style={{ fontSize: '10px', fontWeight: '700', color: '#888', letterSpacing: '.5px', marginBottom: '10px' }}>ETAT</div>
            <div style={{ display: 'flex', gap: '8px' }}>
              {etats.map(e => (
                <button key={e} onClick={() => { setActiveEtat(e); setPage(1); }}
                  style={{ flex: '1', padding: '8px', border: `1.5px solid ${activeEtat === e ? '#F5620A' : '#333'}`, borderRadius: '8px', background: activeEtat === e ? 'rgba(245,98,10,.15)' : 'transparent', color: activeEtat === e ? '#F5620A' : '#888', fontSize: '12px', fontWeight: '700', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                  {e}
                </button>
              ))}
            </div>
          </div>

          {/* CATEGORIE */}
          <div style={{ marginBottom: '20px', borderTop: '1px solid #2A2A2A', paddingTop: '16px' }}>
            <div style={{ fontSize: '10px', fontWeight: '700', color: '#888', letterSpacing: '.5px', marginBottom: '10px' }}>CATEGORIE</div>
            {categories.map(c => (
              <div key={c} onClick={() => { setActiveCat(c); setPage(1); }}
                style={{ padding: '7px 12px', borderRadius: '7px', cursor: 'pointer', fontSize: '12px', fontWeight: '600', marginBottom: '3px', background: activeCat === c ? 'rgba(245,98,10,.15)' : 'transparent', color: activeCat === c ? '#F5620A' : '#888', border: activeCat === c ? '1px solid rgba(245,98,10,.3)' : '1px solid transparent' }}>
                {c}
              </div>
            ))}
          </div>

          {/* PRIX */}
          <div style={{ marginBottom: '20px', borderTop: '1px solid #2A2A2A', paddingTop: '16px' }}>
            <div style={{ fontSize: '10px', fontWeight: '700', color: '#888', letterSpacing: '.5px', marginBottom: '10px' }}>
              PRIX MAX : <span style={{ color: '#F5620A' }}>{priceMax.toLocaleString('fr-FR')} FCFA</span>
            </div>
            <input type="range" min="5000" max="1000000" step="5000" value={priceMax}
              onChange={e => { setPriceMax(Number(e.target.value)); setPage(1); }}
              style={{ width: '100%', accentColor: '#F5620A' }} />
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: '#666', marginTop: '4px' }}>
              <span>5 000 F</span><span>1 000 000 F</span>
            </div>
          </div>
        </div>

        {/* MAIN */}
        <div style={{ padding: '24px 32px', background: '#0A0A0A' }}>

          {/* SEARCH + SORT */}
          <div style={{ display: 'flex', gap: '12px', marginBottom: '20px', flexWrap: 'wrap' }}>
            <input value={searchTerm} onChange={e => { setSearchTerm(e.target.value); setPage(1); }}
              placeholder="Rechercher une piece, une reference..." className="s-input" style={{ flex: '1', minWidth: '200px' }} />
            <select value={sortBy} onChange={e => { setSortBy(e.target.value); fetchAnnonces(); }} className="s-sel" style={{ minWidth: '180px' }}>
              <option value="recent">Plus recents</option>
              <option value="prix-asc">Prix croissant</option>
              <option value="prix-desc">Prix decroissant</option>
            </select>
          </div>

          {/* RESULTS COUNT */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
            <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '20px', letterSpacing: '1px', color: '#fff' }}>
              {loading ? '...' : total} <span style={{ color: '#F5620A' }}>RESULTATS</span>
            </div>
            <div style={{ display: 'flex', gap: '6px' }}>
              {types.slice(1).map(t => (
                <button key={t} onClick={() => { setActiveType(activeType === t ? 'Tous' : t); setPage(1); }}
                  style={{ padding: '5px 12px', border: `1.5px solid ${activeType === t ? '#F5620A' : '#333'}`, borderRadius: '20px', background: activeType === t ? 'rgba(245,98,10,.15)' : 'transparent', color: activeType === t ? '#F5620A' : '#888', fontSize: '11px', fontWeight: '700', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                  {t}
                </button>
              ))}
            </div>
          </div>

          {/* LOADING */}
          {loading && (
            <div style={{ textAlign: 'center', padding: '60px 20px' }}>
              <div style={{ fontSize: '32px', marginBottom: '16px' }}>⏳</div>
              <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '20px', color: '#fff' }}>CHARGEMENT...</div>
            </div>
          )}

          {/* GRID */}
          {!loading && annonces.length > 0 && (
            <div className="prod-grid">
              {annonces.map((p, index) => {
                const firstPhoto = getFirstPhoto(p.photos);
                return (
                  <React.Fragment key={p.id}>
                    {index === 4 && (
                      <div style={{ gridColumn: '1/-1', border: '1.5px dashed rgba(240,180,41,.4)', background: 'rgba(240,180,41,.05)', borderRadius: '10px', padding: '0 14px', height: '66px', display: 'flex', alignItems: 'center', gap: '10px', position: 'relative', cursor: 'pointer' }}>
                        <span style={{ position: 'absolute', top: '6px', left: '6px', background: '#F0B429', color: '#000', fontSize: '9px', fontWeight: '800', padding: '2px 8px', borderRadius: '4px' }}>PUB · INLINE</span>
                        <span style={{ position: 'absolute', top: '6px', right: '6px', fontSize: '9px', fontWeight: '800', color: '#F0B429' }}>15 000 F/sem · 55 000 F/mois</span>
                        <div style={{ width: '36px', height: '36px', background: '#1C1C1C', border: '1px solid #333', borderRadius: '7px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px', flexShrink: 0, marginTop: '6px' }}>🔑</div>
                        <div style={{ flex: 1, paddingTop: '14px' }}>
                          <div style={{ fontSize: '9px', fontWeight: '700', color: '#888', letterSpacing: '.3px' }}>SERRURIER AUTO DAKAR</div>
                          <div style={{ fontSize: '12px', fontWeight: '800', color: '#fff' }}>Cle de voiture perdue ? Intervention en 30 min</div>
                        </div>
                        <button style={{ flexShrink: 0, padding: '6px 12px', background: '#F5620A', border: 'none', borderRadius: '6px', fontSize: '11px', fontWeight: '800', color: '#fff', cursor: 'pointer', marginTop: '6px', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>Appeler</button>
                      </div>
                    )}
                    <Link to={`/produit/${p.id}`} style={{ textDecoration: 'none' }}>
                      <div className="pcard">
                        <div className="pimg">
                          {firstPhoto ? (
                            <img
                              src={firstPhoto}
                              alt={p.nom_piece}
                              style={{ width: '100%', height: '145px', objectFit: 'cover', display: 'block' }}
                              onError={e => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
                            />
                          ) : null}
                          <div className="pimg-icon" style={{ display: firstPhoto ? 'none' : 'flex' }}>🔧</div>
                          <span className={`pbadge ${p.etat === 'Neuf' ? 'pb-n' : 'pb-u'}`}>{p.etat}</span>
                        </div>
                        <div className="pbody">
                          <div className="pcat">{p.type_vehicule?.toUpperCase()} · {p.categorie?.toUpperCase()}</div>
                          <div className="pname">{p.nom_piece}</div>
                          <div className="pref">Ref : {p.reference || 'N/A'}</div>
                          <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap', marginBottom: '8px' }}>
                            <span style={{ fontSize: '10px', fontWeight: '700', background: 'rgba(255,255,255,.06)', color: '#888', padding: '2px 7px', borderRadius: '4px' }}>{p.marque_vehicule}</span>
                            <span style={{ fontSize: '10px', fontWeight: '700', background: 'rgba(255,255,255,.06)', color: '#888', padding: '2px 7px', borderRadius: '4px' }}>{p.annee_vehicule}</span>
                            <span style={{ fontSize: '10px', fontWeight: '700', background: 'rgba(255,255,255,.06)', color: '#888', padding: '2px 7px', borderRadius: '4px' }}>📍 {p.vendeur_ville}</span>
                          </div>
                          <div className="pfoot">
                            <div>
                              <div className="pprice">{parseInt(p.prix).toLocaleString('fr-FR')} <sub>FCFA</sub></div>
                              {p.garantie === 1 && <span style={{ fontSize: '10px', color: '#22C55E', fontWeight: '700' }}>✓ Garantie {p.garantie_duree}</span>}
                            </div>
                            <button className="padd">🛒</button>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </React.Fragment>
                );
              })}
            </div>
          )}

          {/* EMPTY STATE */}
          {!loading && annonces.length === 0 && (
            <div style={{ textAlign: 'center', padding: '60px 20px', color: '#888' }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔍</div>
              <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '24px', color: '#fff', marginBottom: '8px' }}>AUCUNE ANNONCE</div>
              <div style={{ fontSize: '14px', marginBottom: '20px' }}>Soyez le premier a deposer une annonce !</div>
              <Link to="/deposer-annonce">
                <button style={{ padding: '12px 24px', background: '#F5620A', border: 'none', borderRadius: '9px', fontSize: '14px', fontWeight: '800', color: '#fff', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                  Deposer une annonce
                </button>
              </Link>
            </div>
          )}

          {/* PAGINATION */}
          {!loading && total > 12 && (
            <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginTop: '24px' }}>
              <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}
                style={{ padding: '8px 16px', border: '1.5px solid #333', borderRadius: '8px', background: 'transparent', color: page === 1 ? '#444' : '#fff', cursor: page === 1 ? 'not-allowed' : 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif', fontWeight: '700' }}>
                ← Précédent
              </button>
              <span style={{ padding: '8px 16px', fontSize: '13px', color: '#888', fontWeight: '700' }}>
                Page {page} / {Math.ceil(total / 12)}
              </span>
              <button onClick={() => setPage(p => p + 1)} disabled={page >= Math.ceil(total / 12)}
                style={{ padding: '8px 16px', border: '1.5px solid #333', borderRadius: '8px', background: 'transparent', color: page >= Math.ceil(total / 12) ? '#444' : '#fff', cursor: page >= Math.ceil(total / 12) ? 'not-allowed' : 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif', fontWeight: '700' }}>
                Suivant →
              </button>
            </div>
          )}
        </div>
      </div>

      {/* FOOTER */}
      <footer>
        <div className="footer-bottom" style={{ padding: '20px 48px' }}>
          <span>2025 TekTeck · <span className="footer-domain">tekteck.com</span></span>
          <span style={{ color: '#666' }}>Confidentialite · CGU · CGV</span>
        </div>
      </footer>
    </div>
  );
}

export default CataloguePage;